<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("CATEGORIES.EDIT_CATEGORY") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <category-form
              :loading="loading"
              :categoryData="category"
              :formErrors="formErrors"
              @categorySubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryForm from "./partials/CategoryForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultWarehouse from "./defaultCategory";

export default {
  layout: "DashboardLayout",

  components: { CategoryForm },

  mixins: [alertLeave],

  data() {
    return {
      category: cloneDeep(defaultWarehouse),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("categories/get", id);
        this.category = this.$store.getters["categories/category"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List Categories" });
    },

    viewWarehouse() {
      this.alertLeave = false;
      this.$router.push({
        name: "View Category",
        params: { id: this.category.id },
      });
    },

    async handleSubmit(category) {
      this.loading = true;
      const categoryData = cloneDeep(category);

      try {
        await this.$store.dispatch("categories/update", categoryData);
        this.$notify({
          type: "success",
          message: this.$t("CATEGORIES.CATEGORY_UPDATED"),
        });
        this.viewWarehouse();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
